module.exports = __webpack_public_path__ + "assets/img/tb_img.d356ca47.png";